// extracted by mini-css-extract-plugin
export default {"headerText":"styles__headerText__SNZFU"};